import {
    SHOW_TEXT_OVERLAY,
    DISMISS_TEXT_OVERLAY
} from '../constants';


export function showTextOverlay(payload) {
    return {
        type: SHOW_TEXT_OVERLAY,
        payload: {
          text: payload.text,
          headline: payload.headline,
          download: payload.download,
          downloadStr:payload.downloadStr,
          download2: payload.download2,
          downloadStr2:payload.downloadStr2
        }
    }
}

export function hideTextOverlay() {
    return {
        type: DISMISS_TEXT_OVERLAY,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/textoverlay.js